//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'Forrest_info',
}



// WEBPACK FOOTER //
// ./src/pages/formulasInfo/GIT/Chart_Forrest_info.vue